import { render, staticRenderFns } from "./ApproveApplication.vue?vue&type=template&id=e749b546&"
import script from "./ApproveApplication.vue?vue&type=script&lang=js&"
export * from "./ApproveApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports